module.exports = __webpack_public_path__ + "static/media/gt.7268fb31.svg";